var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRateServiceOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 330,
    viewBox: "0 0 130 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.6057 52.6175C63.6057 52.6175 92.6309 89.7265 59.5041 127.483L47.0528 126.334C47.0528 126.334 71.0137 87.9086 60.3412 57.277L42.7 58.5725L32.9482 52.2205L63.6057 52.6175Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3203 4.74764L124.23 0.00451619C126.03 -0.0790628 127.557 1.00748 127.599 2.42833L129.671 58.0083C129.734 59.4292 128.269 60.641 126.469 60.6828C109.832 61.038 35.9406 62.5843 32.697 62.835C29.4743 63.0857 29.2441 18.371 29.2231 7.33859C29.2231 5.98043 30.5834 4.85211 32.3203 4.74764Z",
    fill: "#91B3FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1615 60.8291L34.0987 60.5992C32.7176 55.5218 31.7968 34.6062 31.7759 7.3177C31.7759 7.00428 32.0688 6.73267 32.4246 6.71177L124.334 1.96866C124.502 1.96866 124.669 2.01044 124.795 2.09402C124.941 2.1985 125.025 2.36567 125.046 2.53283L127.118 58.1128C127.138 58.4471 126.845 58.7187 126.469 58.7396H126.448C113.201 59.0112 46.5291 60.4321 34.3917 60.8291H34.1615ZM124.397 2.57461C124.376 2.57461 124.376 2.57461 124.397 2.57461L32.4665 7.3177C32.4246 7.3177 32.4037 7.33861 32.3827 7.33861C32.4246 34.1465 33.3035 54.7905 34.6428 60.2022C47.3871 59.7843 113.306 58.4053 126.448 58.1128H126.469C126.49 58.1128 126.511 58.0918 126.532 58.0918L124.439 2.55372C124.439 2.57462 124.418 2.57461 124.397 2.57461Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4008 11.1832C92.4635 12.5831 92.9867 13.7114 93.5517 13.6905L119.103 12.5622C119.689 12.5413 120.108 11.3712 120.045 9.9713C119.982 8.57138 119.459 7.44308 118.894 7.46397L93.3425 8.59228C92.7565 8.61317 92.338 9.78324 92.4008 11.1832Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 18.0994C92.5265 18.8098 93.0288 19.3531 93.6147 19.3322L119.166 18.2039C119.752 18.183 120.191 17.5979 120.15 16.8875C120.129 16.1771 119.626 15.6338 119.041 15.6547L93.4892 16.783C92.9241 16.8039 92.4847 17.4099 92.5056 18.0994Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 23.4066C92.5265 24.1171 93.0288 24.6603 93.6147 24.6394L119.166 23.5111C119.752 23.4902 120.191 22.9052 120.15 22.1947C120.129 21.4843 119.626 20.9411 119.041 20.9619L93.4892 22.0903C92.9241 22.1112 92.4847 22.6962 92.5056 23.4066Z",
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4949 54.2264C56.9298 54.2264 56.5741 54.2264 56.4694 54.2264C55.8416 54.2264 55.3394 53.7667 55.2557 53.1398L53.0375 34.0003C52.9956 33.666 53.1003 33.3526 53.2886 33.1018C53.4979 32.8511 53.7908 32.6839 54.1047 32.6421C54.1466 32.6421 55.9672 32.4123 57.453 31.4302C57.9552 31.0959 58.5412 29.5497 59.0643 28.1916C59.8596 26.1021 60.8431 23.4903 62.6637 21.4217C65.6144 18.0576 65.1121 13.022 65.0494 12.4579C64.9029 11.2251 65.8655 9.40724 67.3513 8.82219C68.2721 8.46698 70.0927 8.27892 72.1016 11.037C74.5919 14.4846 73.5037 19.1233 72.7922 22.1948C72.562 23.156 72.3527 24.0544 72.3318 24.5977C72.3318 24.6186 72.3318 24.6395 72.3318 24.6604C72.9596 25.0574 75.7847 24.6186 77.4798 24.3469C78.3796 24.2007 79.3004 24.0544 80.2211 23.95C83.3811 23.5739 87.106 23.7201 87.8175 28.0662C88.1105 29.8631 87.3362 31.2004 86.5619 32.0571C87.964 33.2481 88.6755 34.5644 88.7174 35.9435C88.7383 37.1972 88.1942 38.2419 87.6082 38.9732C88.822 40.1015 89.3451 41.6478 89.0103 43.3193C88.7801 44.4685 88.1523 45.5133 87.3362 46.2446C87.964 46.955 88.0477 47.7281 88.0268 48.1251C87.964 50.2564 85.4109 52.3667 81.9371 53.1607C77.7518 54.1637 61.7639 54.2264 57.4949 54.2264ZM55.6115 34.8361L57.5786 51.7817C61.8685 51.7817 77.5216 51.6981 81.414 50.8205C84.1763 50.1937 85.5993 48.7311 85.6202 48.1042C85.6202 47.8535 85.1598 47.561 84.4693 47.352C83.9042 47.1849 83.5276 46.6416 83.5903 46.0565C83.6531 45.4715 84.1135 45.0118 84.6994 44.9491C85.5365 44.8656 86.4364 43.9253 86.6456 42.8597C86.7921 42.0866 86.6665 41.0209 85.1808 40.2478C84.8041 40.0598 84.553 39.6628 84.532 39.2449C84.5111 38.827 84.6994 38.4091 85.0343 38.1584C85.0343 38.1584 86.3108 37.1763 86.2899 36.0062C86.248 34.8779 84.9924 33.8331 83.967 33.1645C83.6113 32.9347 83.402 32.5377 83.402 32.0989C83.4229 31.681 83.6531 31.284 84.0089 31.075C84.0716 31.0333 85.683 30.0721 85.4109 28.4423C85.2226 27.2304 84.9924 25.8514 80.5141 26.3737C79.6561 26.4782 78.7563 26.6245 77.8774 26.7498C74.6128 27.2513 72.0179 27.6483 70.6786 26.4364C70.3019 26.1021 69.8625 25.4753 69.9043 24.4723C69.9462 23.6992 70.1764 22.738 70.4275 21.6306C71.0762 18.8307 71.9761 15.007 70.1345 12.4579C69.423 11.4758 68.7115 10.9325 68.293 11.0788C67.8535 11.2251 67.4978 11.9355 67.4978 12.1862C67.5815 12.834 68.1674 18.8725 64.5262 23.0097C62.9985 24.744 62.1406 27.0215 61.3872 29.0482C60.6129 31.075 60.006 32.6839 58.8551 33.457C57.7041 34.2093 56.4904 34.6271 55.6115 34.8361Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7217 234.318C47.7217 234.318 24.2002 285.51 11.8535 306.697C11.8535 306.697 9.40513 320.028 11.8535 324.228L13.9462 325.147L4.1944 324.855C4.1944 324.855 3.33641 306.906 4.00606 305.903C4.67572 304.9 6.03595 304.963 6.03595 304.963C6.03595 304.963 10.2213 271.908 22.3168 264.845L34.0567 224.497L47.7217 234.318Z",
    fill: "url(#paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1112 327.676C18.1321 327.905 10.4939 327.801 6.35047 327.717C4.82283 327.697 3.52538 326.61 3.19055 325.126L0.05156 308.724C-0.241412 307.157 0.742138 305.653 2.29071 305.297L4.02762 304.9C4.02762 304.9 6.51788 308.306 5.7436 311.524C4.96931 314.742 4.25781 323.058 6.24584 324.019C8.23386 324.98 13.9259 325.168 13.9259 325.168C13.9259 325.168 17.9857 325.565 18.1112 327.676Z",
    fill: "url(#paint6_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0091 327.968C70.7834 328.407 70.4695 329.577 69.5697 329.577C62.6429 329.514 47.0945 329.284 45.7133 328.72C43.9346 327.989 46.362 321.595 48.9151 319.422L63.0406 324.019L70.0091 327.968Z",
    fill: "url(#paint7_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4037 231.058C74.4037 231.058 59.211 304.482 54.9001 318.795L65.0705 325.168C65.0705 325.168 59.9644 324.312 56.1976 324.019C52.4099 323.747 48.936 319.422 48.936 319.422L50.1498 317.479C50.1498 317.479 53.9584 244.452 53.0377 236.178L74.4037 231.058Z",
    fill: "url(#paint8_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.134 59.8053C112.134 59.8053 114.227 98.0008 79.4053 117.517L87.7968 136.614C87.7968 136.614 119.333 117.579 118.161 65.6349C118.119 64.1514 118.664 62.6888 119.647 61.5604L126.344 53.8085C128.897 50.8414 129.859 46.8296 128.897 43.0477L128.018 39.5374C127.725 38.3673 126.385 37.7822 125.318 38.4091L124.628 38.8061C122.388 40.1015 120.631 42.0656 119.584 44.4058L116.299 51.7399C115.064 54.4771 112.239 56.1487 109.247 55.898L107.217 55.7308L112.134 59.8053Z",
    fill: "url(#paint9_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6189 114.654C74.8013 116.263 55.0465 121.445 42.7417 121.236L50.3171 163.861L49.7103 170.819L74.3827 170.715C74.3827 170.715 81.3304 154.605 86.8131 146.581C88.4036 144.262 87.2107 141.504 86.3109 138.829L87.5456 138.014C88.8012 137.178 89.3453 135.611 88.8849 134.191L82.8789 115.845C82.5232 114.905 81.5606 114.382 80.6189 114.654Z",
    fill: "url(#paint10_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3293 167.058L75.8479 171.279C75.8479 171.279 82.8165 192.132 72.3532 240.795C72.3532 240.795 49.7106 247.21 31.0859 231.873C31.0859 231.873 36.3385 185.926 37.7615 183.774C44.8975 173.117 49.6688 170.798 49.6688 170.798L49.878 166.201C49.899 166.201 69.8002 169.795 76.3293 167.058Z",
    fill: "url(#paint11_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6822 118.081C66.7659 117.976 61.5343 102.305 61.5343 102.305L54.0425 102.995L51.1128 120.776C51.0919 120.755 62.8526 123.116 66.6822 118.081Z",
    fill: "url(#paint12_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8208 77.5867C56.323 77.9001 71.8505 84.3148 68.5023 100.404C68.3139 101.365 67.6652 102.159 66.7863 102.556C64.5053 103.58 59.6085 105.314 53.7281 104.708C45.5876 103.872 40.2723 89.7056 40.4815 85.5894C40.7327 81.4522 50.8611 74.4943 55.8208 77.5867Z",
    fill: "url(#paint13_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0914 71.3183C51.5099 71.381 60.0689 74.348 55.8208 80.5538C51.5727 86.7595 49.9823 90.3952 51.9912 93.1115C53.8119 95.598 57.8716 94.1771 57.5159 99.3381C57.4531 100.362 57.8926 101.365 58.7505 101.95C62.5801 104.541 71.8924 112.481 62.6638 123.806C61.9105 124.725 61.764 126 62.329 127.045C65.0285 131.892 70.7206 146.08 50.1497 153.957C29.83 161.73 22.4847 148.462 20.4339 143.175C19.9945 142.026 18.8644 141.337 17.6297 141.378C15.3906 141.483 12.2307 141.107 12.3772 138.14C12.4609 136.322 13.5909 134.713 14.9302 133.397C16.2486 132.101 15.9975 129.865 14.3861 128.946C13.1724 128.256 12.1051 127.191 11.6447 125.498C10.4101 120.943 12.8794 107.32 25.9585 105.001C27.0467 104.813 28.1977 103.789 28.3442 102.681C28.3442 102.66 28.3442 102.64 28.3442 102.64C28.5116 101.574 28.1558 100.487 27.2978 99.8605C25.2052 98.3352 22.5266 95.2428 24.7029 90.3116C26.6282 85.9237 30.3322 84.4611 33.0736 83.9805C34.6849 83.7089 35.7522 82.1836 35.4174 80.5747C34.4966 76.2495 35.3127 69.2706 51.0914 71.3183Z",
    fill: "url(#paint14_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 43.297,
    y1: 47.8941,
    x2: 64.1066,
    y2: 111.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 31.783,
    y1: 31.3938,
    x2: 127.127,
    y2: 31.3938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 92.393,
    y1: 10.568,
    x2: 120.046,
    y2: 10.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 92.5088,
    y1: 17.4888,
    x2: 120.153,
    y2: 17.4888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 92.5088,
    y1: 22.7876,
    x2: 120.153,
    y2: 22.7876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 47.7139,
    y1: 274.84,
    x2: 3.74567,
    y2: 274.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: -12.721,
    y1: 176.663,
    x2: 8.98876,
    y2: 317.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 33.3512,
    y1: 169.587,
    x2: 55.0608,
    y2: 310.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 74.3941,
    y1: 278.104,
    x2: 48.933,
    y2: 278.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 129.242,
    y1: 87.3695,
    x2: 79.3973,
    y2: 87.3695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 135.759,
    y1: 25.7782,
    x2: 99.4103,
    y2: 82.5251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 96.8741,
    y1: 163.257,
    x2: 15.3598,
    y2: 255.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 66.6759,
    y1: 111.804,
    x2: 51.0951,
    y2: 111.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 41.9125,
    y1: 91.6994,
    x2: -71.4941,
    y2: 99.4229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 23.2723,
    y1: 84.8738,
    x2: 63.0946,
    y2: 164.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateServiceOne);
export default __webpack_public_path__ + "static/media/RateServiceOne.dea35362.svg";
export { ForwardRef as ReactComponent };